"use strict";

export default class DomHelper {
	/**
	 * Fetch raw value from dom element
	 * @param {String} identifier
	 * @return {String} value
	 */
	static fetchElementValue(identifier) {
		let element = this._grepElement(identifier);
		return element ? element.innerHTML : '';
	}

	/**
	 * Insert HTML before a certain html element
	 * @param {String} identifier
	 * @param {String} wrapperClass
	 * @param {String} wrapperClassStyle
	 * @param {String} content [More specifically HTML]
	 * @param {String} style
	 */
	static insertBefore(identifier, wrapperClass, wrapperClassStyle, content, style) {
		const contentElement = this._createContentElement(wrapperClass, wrapperClassStyle, content, style);

		const element = this.getElement(identifier);
		element.parentNode.insertBefore(contentElement, element);
	}

	/**
	 * Insert HTML after a certain html element
	 * @param {String} identifier
	 * @param {String} wrapperClass
	 * @param {String} wrapperClassStyle
	 * @param {String} content [More specifically HTML]
	 * @param {String} style
	 */
	static insertAfter(identifier, wrapperClass, wrapperClassStyle, content, style) {
		const contentElement = this._createContentElement(wrapperClass, wrapperClassStyle, content, style);

		const element = this.getElement(identifier);
		element.insertAdjacentElement("afterend", contentElement);
	}

	/**
	 * Prepend HTML to a certain element
	 * @param {String} identifier
	 * @param {String} wrapperClass
	 * @param {String} wrapperClassStyle
	 * @param {String} content [More specifically HTML]
	 * @param {String} style
	 */
	static insertPrepend(identifier, wrapperClass, wrapperClassStyle, content, style) {
		const contentElement = this._createContentElement(wrapperClass, wrapperClassStyle, content, style);

		const element = this.getElement(identifier);
		element.insertBefore(contentElement, element.firstChild);
	}

	/**
	 * Append HTML to a certain element
	 * @param {String} identifier
	 * @param {String} wrapperClass
	 * @param {String} wrapperClassStyle
	 * @param {String} content [More specifically HTML]
	 * @param {String} style
	 */
	static insertAppend(identifier, wrapperClass, wrapperClassStyle, content, style) {
		const contentElement = this._createContentElement(wrapperClass, wrapperClassStyle, content, style);

		const element = this.getElement(identifier);
		element.appendChild(contentElement);
	}

	/**
	 * Toggle element display
	 * @param  {String} identifier
	 * @return
	 */
	static toggleElementDisplay(identifier) {
		let element = this.getElement(identifier);

		if (element.style.display === 'none') {
			element.style.display = 'block';
			return;
		}

		element.style.display = 'none';
	}

	/**
	 * Show element
	 * @param  {Mixed} identifier
	 * @param  {String} displayType
	 * @return
	 */
	static show(identifier, displayType = 'block') {
		let element = this.getElement(identifier);
		if (element && element.style && element.offsetParent === null) {
			if (displayType.includes('!important')) {
				let _tmpValue = displayType.replace(/!important/, '');
				element.style.setProperty('display', _tmpValue, 'important');
			} else {
				element.style.display = displayType;
			}
		}
	}

	/**
	 * Hide element
	 * @param {Mixed} identifier
	 * @param {String} displayType
	 * @return
	 */
	static hide(identifier, displayType = 'none') {
		let element = this.getElement(identifier);
		if (element && element.style && element.offsetParent !== null) {
			if (displayType.includes('!important')) {
				let _tmpValue = displayType.replace(/!important/, '');
				element.style.setProperty('display', _tmpValue, 'important')
			} else {
				element.style.display = displayType;
			}
		}
	}

	/**
	 * Enable element
	 * @param  {Mixed} identifier
	 * @return
	 */
	static enable(identifier) {
		let element = this.getElement(identifier);
		if (element) {
			element.disabled = false;
		}
	}

	/**
	 * Disable element
	 * @param  {Mixed} identifier
	 * @return
	 */
	static disable(identifier) {
		let element = this.getElement(identifier);
		if (element) {
			element.disabled = true;
		}
	}

	/**
	 *
	 * @param identifier
	 * @return {*}
	 */
	static getElement(identifier) {
		return typeof identifier == "string" ? this._grepElement(identifier) : identifier;
	}

	/**
	 * Grep / Fetch element from DOM, based on an identifier (can be both class and id)
	 * @param {String} identifier
	 * @return {Object} element
	 */
	static grepElementIgnoreErrors(identifier) {
		try {
			return document.querySelector(identifier);
		} catch (error) {
		}

		return null;
	}

	/**
	 * Grep / Fetch element from DOM, based on an identifier (can be both class and id)
	 * @param {String} identifier
	 * @return {Object} element
	 */
	static _grepElement(identifier) {
		return document.querySelector(identifier);
	}

	/**
	 * Create content div element
	 * @param wrapperClass
	 * @param wrapperClassStyle
	 * @param content
	 * @param style
	 * @return {HTMLDivElement}
	 * @private
	 */
	static _createContentElement(wrapperClass = '', wrapperClassStyle = '', content = '', style = '') {
		const contentElem = document.createElement("div");
		contentElem.classList.add("sparxpres_web_sale");
		contentElem.classList.add(wrapperClass);
		if (wrapperClassStyle) contentElem.style.cssText = wrapperClassStyle;
		contentElem.innerHTML = content;

		if (style) {
			const styleElem = document.createElement("style");
			styleElem.innerHTML = style;

			contentElem.appendChild(styleElem);
		}

		return contentElem;
	}

}